var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBearbeitenStiftGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.63 22.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    className: "cls-1",
    d: "M0,17.92v4.71H4.71l13.9-13.9-4.71-4.72L0,17.92ZM22.26,5.08c.49-.49,.49-1.28,0-1.77,0,0,0,0,0,0L19.32,.37c-.49-.49-1.28-.49-1.77,0,0,0,0,0,0,0l-2.3,2.3,4.71,4.71,2.3-2.3h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearbeitenStiftGrau);
export default __webpack_public_path__ + "static/media/Bearbeiten Stift_grau.4197c7aab6658780c755288f48187abe.svg";
export { ForwardRef as ReactComponent };